import { UserProfile } from '@shared/types/user';
import { MediaItem } from '../../spaces/types/space.types';

import { Timestamp } from 'firebase/firestore';


export enum ResourceStatus {
  READY = 'Ready',
  IN_PROGRESS = 'In Progress',
  COMING_SOON = 'Coming Soon',
}

export enum ResourceSortType {
  NEWEST = 'newest',
  POPULAR = 'popular',
}

export enum ResourceApprovalStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
}

export interface ResourceMaterial {
  id?: string;
  resourceId: string;
  title: string;
  image?: MediaItem[];
  resourceUrl?: string;
  resourceFile?: MediaItem[];
  category: string;
  status: ResourceStatus;
  createdAt: Timestamp;
  updatedAt: Timestamp;
}

export interface Resource {
  id?: string;
  authorId: string;
  title: string;
  description: string;
  featuredImage?: MediaItem[];
  materials: ResourceMaterial[];
  createdAt: Timestamp;
  updatedAt: Timestamp;
  isDeleted: boolean;
  author?: Partial<UserProfile>;
  approvalStatus: ResourceApprovalStatus;
  reviewedBy?: string;
  reviewedByProfile?: Partial<UserProfile>;
  reviewedAt?: Timestamp;
  reviewComment?: string;
}

export interface ReviewResourceData {
  status: ResourceApprovalStatus.APPROVED | ResourceApprovalStatus.REJECTED;
  comment?: string;
}

export interface CreateResourceData {
  title: string;
  description: string;
  featuredImage?: MediaItem[];
  materials: {
    title: string;
    image?: MediaItem[];
    resourceUrl?: string;
    resourceFile?: MediaItem[];
    category: string;
    status: ResourceStatus;
  }[];
}

export interface UpdateResourceData {
  title?: string;
  description?: string;
  featuredImage?: MediaItem[];
  materials?: {
    id?: string;
    title?: string;
    image?: MediaItem[];
    resourceUrl?: string;
    resourceFile?: MediaItem[];
    category?: string;
    status?: ResourceStatus;
  }[];
}

export interface ResourcesResponse {
  resources: Resource[];
  total: number;
  currentPage: number;
  hasNextPage: boolean;
}

export interface ResourceResponse {
  success: boolean;
  resource: Resource;
}
